import { AccountInfo } from "@azure/msal-browser";
import { msalInstance } from "../index";

/**
 * Identity accessors backed by the in-memory MSAL account.
 *
 * User identity (name, account id, email, UPN) must never be persisted to
 * sessionStorage/localStorage because Web Storage is readable by any script on
 * the origin and is therefore exfiltratable under XSS (CWE-922).
 */
const getCurrentAccount = (): AccountInfo | null => {
  try {
    return msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0] ?? null;
  } catch {
    return null;
  }
};

/** Directory object id of the signed-in user, or null when not signed in. */
export const getCurrentUserId = (): string | null => getCurrentAccount()?.localAccountId ?? null;

/** Display name of the signed-in user, or null when not signed in. */
export const getCurrentUserName = (): string | null => getCurrentAccount()?.name ?? null;

/** Email/username of the signed-in user, or null when not signed in. */
export const getCurrentUserEmail = (): string | null => getCurrentAccount()?.username ?? null;

/** UPN claim of the signed-in user, or null when unavailable. */
export const getCurrentUserPrincipalName = (): string | null => {
  const claims = getCurrentAccount()?.idTokenClaims as Record<string, unknown> | undefined;
  const upn = claims?.["upn"];
  return typeof upn === "string" ? upn : null;
};
